<template>
  <header class="header-wrapper">
    <div class="header-content">
      <div class="logo-area">
        <div class="logo-icon">
          <img src="@/assets/images/header/logo.png" alt="Logo" class="logo-img" />
        </div>
        <div class="logo-text">
          <h1 class="cn">必诺科技</h1>
          <p class="en">Binuo Technology Co., Ltd.</p>
        </div>
      </div>

      <nav class="nav-menu">
        <router-link to="/index" class="nav-item" active-class="active">首页</router-link>
        <router-link to="/software" class="nav-item" active-class="active">软件产品</router-link>
        <router-link to="/hardware" class="nav-item" active-class="active">硬件设备</router-link>
        <router-link to="/cooperation" class="nav-item" active-class="active">学校合作</router-link>
      </nav>

      <div class="nav-action">
        <button class="btn-gradient">预约演示</button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader"
};
</script>

<style lang="scss" scoped>
.header-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: #ffffff;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.logo-area {
  display: flex;
  align-items: center;
}

.logo-icon {
  width: 44px;
  height: 44px;
  margin-right: 6px;
  
  .logo-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.logo-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  .cn {
    font-family: "Source Han Sans CN", sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: #3d3d3d;
    line-height: 19px; /* Figma: 0.85em */
    letter-spacing: 0.545em; /* Figma: 54.5% */
    margin: 0;
    margin-bottom: 3px;
  }

  .en {
    font-family: "PingFang SC", sans-serif;
    font-size: 12px; /* Set to 12px for browser support, scale down to 10px */
    font-weight: 400;
    color: #3d3d3d;
    line-height: 19px; /* Figma: 1.87em of 10px */
    margin: 0;
    transform: scale(0.8333); /* 10/12 */
    transform-origin: left top;
    white-space: nowrap;
  }
}

.nav-menu {
  display: flex;
  gap: 40px;
}

.nav-item {
  font-family: "PingFang SC", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #3d3d3d;
  text-decoration: none;
  position: relative;
  transition: color 0.3s;

  &.active,
  &:hover {
    color: #6075ff;
    font-weight: 400; /* Maintained regular weight as per Figma active state usually just color */
  }
}

.nav-action {
  .btn-gradient {
    width: 104px;
    height: 34px;
    background: linear-gradient(270deg, #6075ff 0%, #64a0f9 100%);
    border-radius: 25px;
    border: none;
    color: #ffffff;
    font-family: "PingFang SC", sans-serif;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
